import React from "react";
import { PlaceHolderImageContainer } from "./Preview.style";
import AddIcon from "@mui/icons-material/Add";
import { Menu, MenuItem } from "@mui/material";

const AddFileComponent = ({
  openFileDialog,
}: {
  openFileDialog: () => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    openFileDialog();
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <PlaceHolderImageContainer
        aria-controls={open ? "file-option-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        data-testid="more-icon"
        onClick={handleClick}
      >
        <AddIcon />
      </PlaceHolderImageContainer>
      <Menu
        anchorEl={anchorEl}
        id="file-option-menu"
        sx={{ top: -72, left: 56 }}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "bottom" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem>{"Take photo"}</MenuItem>
        <MenuItem data-testid="open-dialog" onClick={openFileDialog}>
          {"Upload media"}
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
};

export default AddFileComponent;
